export const difficultyData = [
    { id: 1, name: 'Any Difficulty' },
    { id: 2, name: 'Cataclysm' },
    { id: 3, name: 'Legend' },
    { id: 4, name: 'Champion' },
    { id: 5, name: 'Veteran' },
    { id: 6, name: 'Recruit' },
    { id: 7, name: 'C1DWONS' },
    { id: 8, name: 'C3DWONS' }
];